import React from 'react';
import {
  NEW_DRAFT_ON_ACCEPTED_CANCEL,
  NEW_DRAFT_ON_ACCEPTED_GO,
  NEW_DRAFT_ON_ACCEPTED_TITLE,
} from '../../utils/writerCopy';
import ShrinkGuardDialog from './ShrinkGuardDialog';

/**
 * Ask before a new draft on an accepted scene (#2027).
 * Keep it accepted is the default. Go ahead continues into today's write.
 * The three strings live in writerCopy.js for Joel to replace.
 */
export default function NewDraftOnAcceptedDialog({ onCancel, onGoAhead }) {
  return (
    <ShrinkGuardDialog
      title={NEW_DRAFT_ON_ACCEPTED_TITLE}
      keepLabel={NEW_DRAFT_ON_ACCEPTED_CANCEL}
      confirmLabel={NEW_DRAFT_ON_ACCEPTED_GO}
      titleId="sw-new-draft-accepted-title"
      onSave={onGoAhead}
      onKeepEditing={onCancel}
    />
  );
}
